<!-- header -->
<template>
  <div class="header-bag">
    <el-row>
      <el-col :span="24" style="display: flex; flex-direction: row">
        <div
          class="logo-header"
          v-if="!isShow"
          style="cursor: pointer"
          @click="mouseOver(true)"
        >
          <div class="logo"></div>
        </div>
        <div
          class="logo-header-one"
          v-if="isShow"
          style="cursor: pointer"
          @click="mouseOver(false)"
        >
          <div class="logo-one"></div>
        </div>
        <div class="header-system">
          <svg-icon icon-class="pricetag" class-name="pricetag"></svg-icon>
          <span style="margin-left：4px">客服系统</span>
        </div>
         <!-- <ThemePicker style="float: right;height: 26px;margin: -3px 8px 0 0;z-index:9999"></ThemePicker> -->
      </el-col>
    </el-row>
  </div>
</template>
<script>
/**
 * 顶部导航栏组件
 * 功能：含 logo 收缩切换、系统名"客服系统"展示，向父组件通知收起状态
 */
import ThemePicker from "@/components/common/ThemePicker";
export default {
  components: { ThemePicker },
  name: "rowheader",
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  watch: {
    // 监听父组件是否隐藏侧边栏
    isCollapse() {
      this.isShow = this.isCollapse;
    },
  },
  methods: {
    /** 点击 logo 切换侧边栏收起状态并通知父组件 */
    mouseOver(val) {
      this.isShow = val;
      this.$emit("statusClick", val);
    },
  },
};
</script>
